import { AxiosResponse } from 'axios';

import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import {
  ICreateSiteData,
  ICreateSiteResponse,
  IDeleteSitesFilters,
  IGetSingleSiteResponse,
  IGetSitesFilters,
  IGetSitesResponse,
  IUpdateSiteData,
} from 'models/http/site';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class SiteHttp {
  private static route = '/sites';

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`${SiteHttp.route}/simple?`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filters: IGetSitesFilters, abortController?: AbortController): Promise<IGetSitesResponse['records']> {
    const query = prepareQPFromFilters(filters);

    return serverAxios
      .get(`${SiteHttp.route}?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSitesResponse>) => {
        return response.data.records;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleSiteResponse> {
    return serverAxios
      .get(`${SiteHttp.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleSiteResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateSiteData): Promise<string> {
    return serverAxios
      .post(SiteHttp.route, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateSiteResponse>) => {
        return response.data.id;
      });
  }

  public async update(id: number, data: IUpdateSiteData): Promise<void> {
    return serverAxios
      .put(`${SiteHttp.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then(() => {
        return;
      });
  }

  public async delete(ids: number[]): Promise<void>;
  public async delete(filters: IDeleteSitesFilters): Promise<void>;
  public async delete(filters: number[] | IDeleteSitesFilters): Promise<void> {
    return serverAxios
      .delete(SiteHttp.route, {
        data: prepareFiltersOfSelection(filters),
        timeout: HttpTimeoutPriority.Low,
      })
      .then(() => {
        return;
      });
  }
}

export default SiteHttp;
